export const FOLDER_APP = process.env.REACT_APP_FOLDER || 'ZebraStorage'
export const DEFAULT_LIFE_TIME = Number(process.env.REACT_APP_DEFAULT_LIFE_TIME) || 600
export const STORAGE_TYPE = process.env.REACT_APP_STORAGE_TYPE || 'ZebraStorage'
export const DEFAULT_MAX_STORAGE = Number(process.env.REACT_APP_DEFAULT_MAX_STORAGE) || 300
export const MB = Number(process.env.REACT_APP_DEFAULT_MB) || 1024 * 1024
export const SUCCESS = "success"
export const MAP_FILE_TYPE = Object.freeze({
    "db": "application/x-sqlite3",
    "sql": "application/sql",
    "mdb": "application/x-msaccess",
    "accdb": "application/x-msaccess",
    "odb": "application/vnd.oasis.opendocument.database",
    "doc": "application/msword",
    "docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "pdf": "application/pdf",
    "txt": "text/plain",
    "odt": "application/vnd.oasis.opendocument.text",
    "rtf": "application/rtf",
    "xls": "application/vnd.ms-excel",
    "xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "csv": "text/csv",
    "ods": "application/vnd.oasis.opendocument.spreadsheet",
    "ppt": "application/vnd.ms-powerpoint",
    "pptx": "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "odp": "application/vnd.oasis.opendocument.presentation",
    "zip": "application/zip",
    "rar": "application/x-rar-compressed",
    "7z": "application/x-7z-compressed",
    "tar": "application/x-tar",
    "gz": "application/gzip",
    "bz2": "application/x-bzip2",
    "jpg": "image/jpeg",
    "jpeg": "image/jpeg",
    "png": "image/png",
    "gif": "image/gif",
    "bmp": "image/bmp",
    "tiff": "image/tiff",
    "svg": "image/svg+xml",
    "mp3": "audio/mpeg",
    "wav": "audio/wav",
    "ogg": "audio/ogg",
    "flac": "audio/flac",
    "m4a": "audio/mp4",
    "mp4": "video/mp4",
    "avi": "video/x-msvideo",
    "mkv": "video/x-matroska",
    "mov": "video/quicktime",
    "webm": "video/webm",
    "exe": "application/x-msdownload",
    "msi": "application/x-ms-installer",
    "dmg": "application/x-apple-diskimage",
    "sh": "application/x-sh",
    "bat": "application/x-msdos-program",
    "py": "text/x-python",
    "js": "application/javascript",
    "java": "text/x-java-source",
    "c": "text/x-c",
    "cpp": "text/x-c++",
    "php": "application/x-httpd-php",
    "html": "text/html",
    "css": "text/css",
    "xml": "application/xml",
    "json": "application/json",
    "ttf": "font/ttf",
    "otf": "font/otf",
    "woff": "font/woff",
    "woff2": "font/woff2",
})

